import { Box, BoxProps } from '@mui/material';
import { PAGE_PADDING_X_NEGATIVE } from '../page/consts';

export function FullWidthBox({ sx, ...props }: BoxProps) {
  return <Box sx={{ mx: PAGE_PADDING_X_NEGATIVE, ...sx }} {...props} />;
}
